import { createTheme } from '@mui/material/styles';

import { getRootTheme } from './root-theme';

export const getThemeDark = () =>
  createTheme({
    ...getRootTheme()
  });
